

/* tslint:disable */



export enum ComponentState {
    InProgress = 1,
    Ready = 2,
    Approved = 3,
    Published = 4,
    Inactive = 5,

}


